import OpenQuestion from 'models/common/form/question/open/OpenQuestion';

export default class EmailOpenQuestion extends OpenQuestion {}
